<template>
  <div class="businessApplicationDetails">
    <!--    <el-button type="primary" @click="print">打印</el-button>-->
    <div class="businessApplicationDetails-first">
      <div id="content" style="margin: 20px 0" class="body">
        <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">发货单号:</td>
            <td>{{complaintInfoVo.billNo}}</td>
            <td class="tableLabel">客户名称:</td>
            <td>{{complaintInfoVo.customerName}}</td>
            <td class="tableLabel">客户需求交期:</td>
            <td>{{complaintInfoVo.customerDeliveryTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">物流单号:</td>
            <td>{{complaintInfoVo.logisticsBillNo}}</td>
            <td class="tableLabel">物流备注:</td>
            <td>{{complaintInfoVo.logisticsDesc}}</td>
            <td class="tableLabel">物流发货日期:</td>
            <td>{{complaintInfoVo.logisticsDeliveryTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">业务发生部门:</td>
            <td>{{complaintInfoVo.businessTypeName}}</td>
            <td class="tableLabel">客户联系人:</td>
            <td>{{complaintInfoVo.contact}}</td>
            <td class="tableLabel">客户联系电话:</td>
            <td>{{complaintInfoVo.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">使用阶段:</td>
            <td>{{complaintInfoVo.usePhase}}</td>
            <td class="tableLabel">损坏位置:</td>
            <td>{{complaintInfoVo.damageLocation}}</td>
            <td class="tableLabel">现场环境:</td>
            <td>{{complaintInfoVo.siteEnvironment}}</td>
          </tr>
          <tr>
            <td class="tableLabel">收件人:</td>
            <td>{{complaintInfoVo.consignee}}</td>
            <td class="tableLabel">联系电话:</td>
            <td>{{complaintInfoVo.consigneePhone}}</td>
            <td class="tableLabel">商务对接人:</td>
            <td>{{complaintInfoVo.businessApprovalName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">送货地址:</td>
            <td>{{complaintInfoVo.deliveryAddress}}</td>
            <td class="tableLabel">故障情况描述:</td>
            <td>{{complaintInfoVo.note}}</td>
            <td class="tableLabel">是否维修后发货:</td>
            <td>{{complaintInfoVo.isFixAfterDelivery ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发货单号:</td>
            <td>{{complaintInfoVo.reserveBillNo}}</td>
            <td class="tableLabel">回复交期:</td>
            <td>{{complaintInfoVo.responseTime}}</td>
            <td class="tableLabel">退回单号:</td>
            <td>
              <span v-if="editAuthReturnBillNo">
                <el-input v-model="complaintInfoVo.returnBillNo" placeholder="请输入" @change="editReturnBill"/>
              </span>
              <span v-else>
                {{complaintInfoVo.returnBillNo}}
              </span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">产品编号:</td>
            <td>{{complaintInfoVo.productCode}}</td>
            <td class="tableLabel">产品型号:</td>
            <td>{{complaintInfoVo.productLine}}</td>
            <td class="tableLabel">是否过保:</td>
            <td>{{complaintInfoVo.isExpired ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">销售订单号:</td>
            <td>{{complaintInfoVo.salesOrderNo}}</td>
            <td class="tableLabel">指导价(元):</td>
            <td>{{complaintInfoVo.guidePrice}}</td>
            <td class="tableLabel">最终价(元):</td>
            <td>{{complaintInfoVo.finalPrice}}</td>
            <!--            <td class="tableLabel">是否同意收费:</td>-->
            <!--            <td>{{complaintInfoVo.isCollectFee ? "是" : "否"}}</td>-->
            <!--            <td v-if="!complaintInfoVo.isCollectFee" class="tableLabel">不同意原因:</td>-->
            <!--            <td v-if="complaintInfoVo.isCollectFee" colspan="3">{{complaintInfoVo.disagreeCause}}</td>-->
          </tr>
          <!--          <tr>-->
          <!--            <td class="tableLabel">最终价审批结果:</td>-->
          <!--            <td>{{complaintInfoVo.finalPriceResult? "同意" : "拒绝"}}</td>-->
          <!--          </tr>-->
          <tr>
            <td class="tableLabel">是否售后:</td>
            <td>{{complaintInfoVo.isAfterSale ? "是" : "否"}}</td>
            <td class="tableLabel">需要质量报告:</td>
            <td>{{complaintInfoVo.isQualitySurvey ? "是" : "否"}}</td>
            <td class="tableLabel">是否退回件:</td>
            <td>{{complaintInfoVo.isSendBack ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">制单人:</td>
            <td>{{complaintInfoVo.creatorName}}</td>
            <td class="tableLabel">制单人部门:</td>
            <td>{{complaintInfoVo.departmentName}}</td>
            <td class="tableLabel">打印状态:</td>
            <td>
              <span v-if="complaintInfoVo.printStatus === 1">已打印</span>
              <span v-else-if="complaintInfoVo.printStatus === 0">未打印</span>
              <span v-else>/</span>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">产品信息备注:</td>
            <td colspan="5">{{complaintInfoVo.productNote}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任判定:</td>
            <td colspan="5">{{complaintInfoVo.responsibility}}</td>
          </tr>
          <tr>
            <td class="tableLabel">质量分析:</td>
            <td colspan="5">{{complaintInfoVo.qualityAnalise}}</td>
          </tr>
        </table>
        <div style="margin-top: 5px;margin-bottom:5px;font-weight: bold">产品信息</div>
        <div style="width: 100%; margin-top: 20px">
          <el-tabs :value="tabActive" type="card">
            <el-tab-pane name="first" label="产品信息-发出">
              <div>
                <el-table
                    :data="complaintInfoVo.details">
                  <el-table-column type="index" align="center" label="序号" width="50"/>
                  <el-table-column prop="materialNo" align="center" label="物料编号" width="80"/>
                  <el-table-column prop="materialName" align="center" label="物料名称"/>
                  <el-table-column prop="quantity" align="center" label="数量" width="60"/>
                  <el-table-column prop="note" align="center" label="备注">
                    <template slot-scope="scope">
                      <el-input v-if="!isPrint" v-model="scope.row.note" autosize type="textarea"/>
                      <span v-if="isPrint">{{scope.row.note}}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane name="second" label="产品信息-退回">
              <div>
                <el-table
                    :data="complaintInfoVo.returnMaterialDetails">
                  <el-table-column prop="rowIndex" align="center" label="序号" width="50"/>
                  <el-table-column prop="materialNo" align="center" label="物料编号" width="100"/>
                  <el-table-column prop="materialName" align="center" label="物料名称"/>
                  <el-table-column prop="quantity" align="center" label="数量" width="130">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.quantity" min="1" type="number"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="note" width="200px" align="center" label="备注">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.note" autosize type="textarea"/>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="240" align="center">
                    <template v-slot="scope">
                      <el-button type="primary" @click="$refs.checkReportPage.open(scope.row,complaintInfoVo,scope.$index,true)">下载检测报告</el-button>
                      <el-button type="primary" @click="$refs.qualityReportPage.open(scope.row,complaintInfoVo,scope.$index,true)">下载质量报告</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="complaintInfoVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述">
          <template slot-scope="scope">
            <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>  
  </div>
</template>

<script>
  import constant from "@/util/constant";

  export default {
    name: "ComplaintInfoPreview",
    components: {},
    data() {
      return {
        constant,
        // onChangeItem: {
        //   deliveryDate: "",
        //   noteOne: "",
        //   noteTwo: "",
        //   noteThree: "",
        //   noteFour: "",
        // },
        tabActive: "first",
        printLoading: false,
        isPrint: false,
        addLoading: false,
        addAuthZTBN: this.$auth(819),
        addAuthZCH1: this.$auth(818),
        addAuthZTB: this.$auth(817),
        editAuthReturnBillNo: this.$auth(826),
        billId: 0,
        billType: 0,
        imgUrls: [],
        complaintInfoVo: {
          pkid: 0,
          billNo: "",
          customerId: "",
          customerName: "",
          creatorName: "",
          contact: "",
          telephone: "",
          deliveryAddress: "",
          salesOrderType: "",
          customerDeliveryTime: "",
          logisticsDeliveryTime: "",
          logisticsBillNo: "",
          logisticsDesc: "",
          reserveBillNo: "",
          responseTime: "",
          returnBillNo: "",
          isExpired: "",
          salesExecutiveNote: "",
          commercialNote: "",
          logisticsNote: "",
          salesReturnNote: "",
          details: [],
          attachments: [],
          notifyLists: [],
        },
      };
    },
    created() {
      this.complaintInfoVo.pkid = this.$route.query.billId + "";
      this.billId = this.$route.query.billId + "";
      this.billType = this.$route.query.billType + "";
      this.getData();
    },
    methods: {
      async getData() {
        await this.$http.get("basic", `complaintInfoes/${this.complaintInfoVo.pkid}`).then((res) => {
          this.complaintInfoVo = res.data;
          this.complaintInfoVo.attachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
        });
      },
      print() {
        this.isPrint = true;
        this.changePrintStatus();
        this.$nextTick(() => {
          document.body.innerHTML = document.getElementById("content").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
          return false;
        });
      },
      changePrintStatus() {
        this.$http
          .get("basic", `complaintInfoes/changePrintStatus/${this.complaintInfoVo.pkid}`)
          .then(() => {
          });
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      editReturnBill() {
        this.$http
          .put("basic", "complaintInfoes/updateById", this.complaintInfoVo)
          .then(() => {
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.$message.error("保存失败");
          });
      },
      convertByEmergencyDelivery() {
        this.addLoading = true;
        this.$http
          .get("basic", `complaintInfoVos/convertByEmergencyDelivery/${this.complaintInfoVo.pkid}`)
          .then(resp => {
            if (resp.success) {
              this.addLoading = false;
              this.$message.success("创建成功");
            } else {
              this.addLoading = false;
              this.$message.error(resp.message);
            }
          }).catch(() => {
            this.addLoading = false;
            this.$message.error("创建失败");
          });
      },
      convertByEmergencyDeliveryV2() {
        this.addLoading = true;
        this.$http
          .get("basic", `complaintInfoes/convertByEmergencyDeliveryV2/${this.complaintInfoVo.pkid}`)
          .then(resp => {
            if (resp.success) {
              this.addLoading = false;
              this.$message.success("创建成功");
            } else {
              this.addLoading = false;
              this.$message.error(resp.message);
            }
          }).catch(() => {
            this.addLoading = false;
            this.$message.error("创建失败");
          });
      },
      convertByEmergencyDeliveryV3() {
        // let isNext = false;
        // if (this.complaintInfoVo.isExpired) {
        // if (this.complaintInfoVo.finalPrice === null || this.complaintInfoVo.finalPrice === "" || this.complaintInfoVo.finalPrice === undefined) {
        //   return  this.$message.error("无最终价价！");
        // }
        // if (this.complaintInfoVo.guidePrice === null || this.complaintInfoVo.guidePrice === "" || this.complaintInfoVo.guidePrice === undefined) {
        //   return  this.$message.error("暂无维修指导价！");
        // }

        //   if (this.complaintInfoVo.finalPrice > this.complaintInfoVo.guidePrice) {
        //     isNext = true;
        //   }else {
        //     if (this.complaintInfoVo.finalPriceResult) {
        //       isNext = true;
        //     }else {
        //       isNext = false;
        //     }
        //   }
        // }else {
        //   return  this.$message.error("非过保产品不需要收费！");
        // }
        // if (!isNext) {
        //   return  this.$message.error("当前订单未通过价格审核，请先通过价格审核");
        // }
        this.addLoading = true;
        this.$http
          .get("basic", `complaintInfoes/convertByEmergencyDelivery_sf/${this.complaintInfoVo.pkid}`)
          .then(resp => {
            if (resp.success) {
              this.addLoading = false;
              this.$message.success("创建成功");
            } else {
              this.addLoading = false;
              this.$message.error(resp.message);
            }
          }).catch(() => {
            this.addLoading = false;
            this.$message.error("创建失败");
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.body {
  span {
    font-size: 14px;
    color: #333333;
    line-height: 30px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 12px;
    color: #333333;
    border: 1px solid #dddddd;
  }

  table.gridtable td {
    padding: 8px;
    border-bottom: 1px solid #dddddd;
    height: 45px;
    box-sizing: border-box;
  }

  table.gridtable tr:last-child td {
    border-bottom: none;
  }

  .tableLabel {
    width: 120px;
    text-align: right;
    background-color: #d1e6f5;
  }
}
</style>
